import styled, { useTheme } from 'styled-components';
import { Link } from 'react-router-dom';
import Typography from 'app/ui/components/atoms/typography';

export type GradientActionCardProps = {
  title: string;
  shortDescription: string;
  ctaImageUrl?: string | null;
  to: string;
  gradientColor?: string;
  size?: 'default' | 'large';
};

const Container = styled.div<{ $gradientColor?: string; $size?: 'default' | 'large' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  border-radius: 0.5rem;
  cursor: pointer;
  &:hover {
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.focoltone};
  }
  ${({ theme: { spacing, colors }, $gradientColor }) => `
    padding: ${spacing(5)};
    background: ${`linear-gradient(90deg, ${$gradientColor} 0%, ${colors.faqGrey} 80%)`};
  `}
`;

const ContentWrapper = styled.div<{ $size?: 'default' | 'large' }>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
  max-width: ${({ $size }) => ($size === 'large' ? '65%' : '75%')};
`;

const Image = styled.img<{ $size?: 'default' | 'large' }>`
  width: ${({ $size }) => ($size === 'large' ? '6rem' : '4rem')};
  height: auto;
  object-fit: contain;

  ${({ theme: { media }, $size }) => `${media.medium(() => ($size === 'large' ? 'width: 9rem;' : 'width: 4rem;'))}`}
`;

const DescriptionWrapper = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const GradientActionCard: React.FC<GradientActionCardProps> = ({
  title,
  shortDescription,
  ctaImageUrl,
  to,
  gradientColor,
  size = 'default',
}) => {
  const theme = useTheme();

  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <Container $gradientColor={gradientColor || theme.colors.gold}>
        <ContentWrapper $size={size}>
          <Typography variant="h5" color={theme.colors.white}>
            {title}
          </Typography>
          <DescriptionWrapper>
            <Typography variant="caption" color={theme.colors.lightGray} htmlContent={shortDescription}>
              {shortDescription}
            </Typography>
          </DescriptionWrapper>
        </ContentWrapper>
        {ctaImageUrl && <Image src={ctaImageUrl} alt={title} loading="lazy" $size={size} />}
      </Container>
    </Link>
  );
};

export default GradientActionCard;
